// src/features/settings/settings.store.ts
// Holds public app settings loaded from the backend on app start.
// Defaults match the current hardcoded values so behaviour is unchanged
// until the API response arrives.

import { create } from 'zustand';
import type { PublicSettingsDto } from '../../api/types';

interface SettingsState {
  hospitalName: string;
  morningCutoffHour: number;
  eveningCutoffHour: number;
  sessionTimeoutSeconds: number;
  sessionWarningSeconds: number;
  whatsAppEnabled: boolean;
  emailEnabled: boolean;
  tokenEnabled: boolean;
  loaded: boolean;
  load: (dto: PublicSettingsDto) => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
  hospitalName: 'RMV Hospital',
  morningCutoffHour: 12,
  eveningCutoffHour: 15,
  sessionTimeoutSeconds: 900,
  sessionWarningSeconds: 60,
  whatsAppEnabled: true,
  emailEnabled: false,
  tokenEnabled: true,
  loaded: false,
  load: (dto) =>
    set({
      hospitalName: dto.hospitalName,
      morningCutoffHour: dto.morningCutoffHour,
      eveningCutoffHour: dto.eveningCutoffHour,
      sessionTimeoutSeconds: dto.sessionTimeoutSeconds,
      sessionWarningSeconds: dto.sessionWarningSeconds,
      whatsAppEnabled: dto.whatsAppEnabled,
      emailEnabled: dto.emailEnabled,
      tokenEnabled: dto.tokenEnabled,
      loaded: true,
    }),
}));
